function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgCaminhaoLeve = function SvgCaminhaoLeve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.574 9.294c.09-.089.21-.139.336-.139h7.138c.155 0 .301.076.39.203l3.114 4.441c.056.08.086.176.086.273v2.398c.295.507.388 1.223.356 1.855a4.18 4.18 0 01-.184 1.051c-.103.323-.26.642-.495.88-.27.275-.638.43-1.022.43h-1.559a2.697 2.697 0 01-5.31 0h-8.9a2.697 2.697 0 01-5.31 0H3.477A.476.476 0 013 20.208v-6.137c0-.263.213-.476.476-.476h13.958V9.631c0-.126.05-.247.14-.337zm-.14 5.254H3.953v1.586h13.482v-1.586zm0 2.538H3.953v2.647h2.263a2.697 2.697 0 015.309 0h5.91v-2.647zm.952 2.647h2.039a2.697 2.697 0 015.31 0h1.558c.129 0 .253-.052.343-.144.093-.094.19-.261.268-.504.076-.237.125-.518.14-.809.03-.609-.089-1.14-.268-1.387a.476.476 0 01-.09-.279v-2.388l-2.885-4.115h-6.415v9.626zm.476-8.833c0-.263.213-.476.476-.476h4.283c.16 0 .311.081.399.216l2.062 3.173a.476.476 0 01-.4.735h-6.344a.476.476 0 01-.476-.476V10.9zm.952.476v2.22h4.992l-1.444-2.22h-3.548zm-.476 3.648c.263 0 .476.213.476.476v.952a.476.476 0 01-.952 0V15.5c0-.263.213-.476.476-.476zm-10.469 3.44a1.745 1.745 0 100 3.49 1.745 1.745 0 000-3.49zm14.21 0a1.745 1.745 0 100 3.49 1.745 1.745 0 000-3.49z",
    fill: props.color
  }));
};
SvgCaminhaoLeve.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgCaminhaoLeve.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgCaminhaoLeve;